/**
 * API Configuration
 * Handles API base URL for different environments
 */

const getAPIBaseUrl = (): string => {
  // Development environment
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';
  }

  // Production environment
  return process.env.REACT_APP_API_BASE_URL || 'https://api.metafitwellness.com';
};

export const API_BASE_URL = getAPIBaseUrl();

export const API_ENDPOINTS = {
  CONTACT_SUBMIT: `${API_BASE_URL}/api/contact/submit`,
  CONTACT_ADMIN_ALL: `${API_BASE_URL}/api/contact/admin/all`,
  CONTACT_ADMIN_GET: (id: string) => `${API_BASE_URL}/api/contact/admin/${id}`,
  CONTACT_ADMIN_UPDATE_STATUS: (id: string) => `${API_BASE_URL}/api/contact/admin/${id}/status`,
  CONTACT_ADMIN_DELETE: (id: string) => `${API_BASE_URL}/api/contact/admin/${id}`,
};

